import { lazy } from 'react';

// project imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';
import PortalThemeProvider from 'themes/PortalThemeProvider';

// login routing
const AuthLogin = Loadable(lazy(() => import('views/pages/authentication/authentication2/Login2')));
const AuthResetPassword = Loadable(lazy(() => import('views/pages/authentication/authentication2/ResetPassword2')));

// candidate routes
const CandidateLogin = Loadable(lazy(() => import('views/pages/authentication/candidate/Login')));

// guest routes
const GuestLogin = Loadable(lazy(() => import('views/pages/authentication/guest/Login')));

const ExpiredLink = Loadable(lazy(() => import('views/pages/ExpiredLink')));
const Error404 = Loadable(lazy(() => import('views/error/Error404')));

const LoginRoutes = {
    path: '/',
    errorElement: <Error404 />,
    element: (
        <NavMotion>
            <GuestGuard>
                <MinimalLayout />
            </GuestGuard>
        </NavMotion>
    ),
    children: [
        {
            path: '/',
            element: <AuthLogin />
        },
        {
            path: '/candidate/:assessmentCode/login',
            element: (
                <PortalThemeProvider>
                    <CandidateLogin />
                </PortalThemeProvider>
            ),
            errorElement: (
                <PortalThemeProvider>
                    <ExpiredLink btnMessage="Go to Login Page" />
                </PortalThemeProvider>
            )
        },
        {
            path: '/candidate/:assessmentCode/login/reset-password/:resetPasswordToken',
            element: (
                <PortalThemeProvider>
                    <CandidateLogin />
                </PortalThemeProvider>
            ),
            errorElement: (
                <PortalThemeProvider>
                    <ExpiredLink btnMessage="Go to Login Page" />
                </PortalThemeProvider>
            )
        },
        {
            path: '/candidate/:assessmentCode/login/:initLoginToken/:email',
            element: (
                <PortalThemeProvider>
                    <CandidateLogin />
                </PortalThemeProvider>
            ),
            errorElement: (
                <PortalThemeProvider>
                    <ExpiredLink btnMessage="Go to Login Page" />
                </PortalThemeProvider>
            )
        },
        {
            path: '/guest/:requestCode/login',
            element: (
                <PortalThemeProvider>
                    <GuestLogin />
                </PortalThemeProvider>
            ),
            errorElement: (
                <PortalThemeProvider>
                    <ExpiredLink btnMessage="Go to Login Page" />
                </PortalThemeProvider>
            )
        },
        {
            path: '/login',
            element: <AuthLogin />,
            children: [
                {
                    path: 'reset-password/:resetPasswordToken',
                    element: <AuthLogin />
                }
            ],
            errorElement: <ExpiredLink btnMessage="Go to Login Page" />
        },
        {
            path: '/reset-password',
            element: <AuthResetPassword />,
            errorElement: <ExpiredLink />
        }
    ]
};

export default LoginRoutes;
